module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASBAMAAACk4JNkAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURUdwTDRKZTVOZTVOZjVNZTRMZDBQYDZOZjZNZjVNZTVNZTZNZTZOZr+6JPsAAAAMdFJOUwAu8KDAQBCA0JBgsCbV6wcAAAB2SURBVAjXY2AAgjMMMABlSYJZExkYGHUWAFlchwQYWA6DxfY4MMSogVlJRxlsCsAszsMMPQJgFusRsAkQjGCBZIGA8QRYBxCwHwabwgA2BWQyENg4AG0zAzKSgbYxCB0qZBDXUQTp8jlz5swRsAmsFmeaAxgYAGobIi78sAZpAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/resp-logout-black.png
// module id = 1029
// module chunks = 0